//@flow
import type { DeliveryResourceType } from 'digicel-kaizen-library';

export type DeliveryResourcesActionType =
  | {|
      type: 'FETCH_DELIVERY_RESOURCES',
    |}
  | {|
      type: 'FETCH_DELIVERY_RESOURCES_SUCCESS',
      payload: {|
        deliveryResources: Array<DeliveryResourceType>,
      |},
    |};

export function fetchDeliveryResources(): DeliveryResourcesActionType {
  return {
    type: 'FETCH_DELIVERY_RESOURCES',
  };
}

export function fetchDeliveryResourcesSuccess(
  deliveryResources: Array<DeliveryResourceType>
): DeliveryResourcesActionType {
  return {
    type: 'FETCH_DELIVERY_RESOURCES_SUCCESS',
    payload: {
      deliveryResources,
    },
  };
}
